// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    addLabor,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    deleteLabor
} from './labor';
import {
    addPart,
    changePartProperty,
    changePartsUnit,
    deletePart
} from './parts';
import {
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    createOtherCredit,
    deleteOtherCredit
} from './other-credits';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetConfirmationModal,
    setConfirmationModal
} from './confirmation-modal';
import {
    resetTrackClaim,
    resetTrackPinDetails,
    resetTrackProductDetails,
    updateInstalledByDropDown,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateStickyHeaderVisibility,
    updateTrackClaimApplication,
    updateTrackClaimFailureDate,
    updateTrackClaimFailurePart,
    updateTrackClaimInputOnBlur,
    updateTrackClaimProperty,
    updateTrackClaimRepairDate,
    updateTrackClaimRepairNumber,
    updateTrackClaimUnitDropDown,
    updateTrackClaimUseAmount,
    updateTrackClaimWorkOrderOne,
    updateTrackClaimWorkOrderTwo,
    updateTrackPin
} from './claim-details';
import {
    updateFailedModeDropDown,
    updateTrackClaimAverageLugHeightAmount,
    updateTrackClaimBasisForSettlement,
    updateTrackClaimComplaintCause,
    updateTrackClaimComplaintCorrection,
    updateTrackClaimDtacCase,
    updateTrackClaimDtacSolution,
    updateTrackClaimFailedModeComments,
    updateTrackClaimLugHeightUnits,
    updateTrackClaimOperatorComments,
    updateTrackClaimOperatorsComplaint,
    updateTrackClaimPartSerialNumber,
    updateTrackClaimPartsUseAmount,
    updateTrackClaimPartsUseUnits
} from './failure-panel';
import {additionalRepair} from './additional-repair';
import {copyAttachments} from '../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createTrackClaim} from './validate-claim';
import {onEditClaim} from '../../shared/action-creators/edit-claim';
import {readApplication} from './get-application';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readDownTime} from '../../shared/action-creators/down-time';
import {readFailureModes} from './failure-modes';
import {readGoodsInstallationVatOptions} from '../../shared/action-creators/get-goods-installation-vat-options';
import {readInstalledBy} from './get-installed-by';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';
import {readLaborTypes} from '../../shared/action-creators/labor-types';
import {readLugheightUOM} from './lug-height-units';
import {readOtherCreditDescriptions} from '../../shared/action-creators/other-credit-descriptions';
import {readOwnershipStatuses} from '../../shared/action-creators/ownership-status';
import {readPartDetails} from './get-part-details';
import {readPartUseUnits} from '../../shared/action-creators/part-use-units';
import {readTrackClaim} from './get-track-claim';
import {resetCkcCustomerFailure} from '../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../shared/action-creators/latest-per-unit-measurements';
import {toggleWarrentyStatusModal} from '../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../product/details/action-creators/warranties';

export default {
    addFile,
    addLabor,
    addPart,
    additionalRepair,
    changeAmount,
    changeComments,
    changeDescription,
    changeDistance,
    changeLaborLocation,
    changeLaborProperty,
    changeLaborType,
    changePartProperty,
    changePartsUnit,
    copyAttachments,
    copyClaim,
    createOtherCredit,
    createTrackClaim,
    deleteFile,
    deleteLabor,
    deleteOtherCredit,
    deletePart,
    onCreateClaim,
    onEditClaim,
    readApplication,
    readClaimProduct,
    readClaimTypes,
    readDownTime,
    readFailureModes,
    readGoodsInstallationVatOptions,
    readInstalledBy,
    readLaborLocations,
    readLaborTypes,
    readLugheightUOM,
    readOtherCreditDescriptions,
    readOwnershipStatuses,
    readPartDetails,
    readPartUseUnits,
    readTrackClaim,
    resetCkcCustomerFailure,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetTrackClaim,
    resetTrackPinDetails,
    resetTrackProductDetails,
    setConfirmationModal,
    toggleWarrentyStatusModal,
    updateClaimModalMode,
    updateCreateClaimModalVisibility,
    updateFailedModeDropDown,
    updateGoodsInstallationVat,
    updateInstalledByDropDown,
    updateIsEditable,
    updateOwnershipStatusDropDown,
    updateResponsibleAccountsDropDown,
    updateSelectedAction,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateTrackClaimApplication,
    updateTrackClaimAverageLugHeightAmount,
    updateTrackClaimBasisForSettlement,
    updateTrackClaimComplaintCause,
    updateTrackClaimComplaintCorrection,
    updateTrackClaimDtacCase,
    updateTrackClaimDtacSolution,
    updateTrackClaimFailedModeComments,
    updateTrackClaimFailureDate,
    updateTrackClaimFailurePart,
    updateTrackClaimInputOnBlur,
    updateTrackClaimLugHeightUnits,
    updateTrackClaimOperatorComments,
    updateTrackClaimOperatorsComplaint,
    updateTrackClaimPartSerialNumber,
    updateTrackClaimPartsUseAmount,
    updateTrackClaimPartsUseUnits,
    updateTrackClaimProperty,
    updateTrackClaimRepairDate,
    updateTrackClaimRepairNumber,
    updateTrackClaimUnitDropDown,
    updateTrackClaimUseAmount,
    updateTrackClaimWorkOrderOne,
    updateTrackClaimWorkOrderTwo,
    updateTrackPin,
    updateWarranties
};



// WEBPACK FOOTER //
// ./src/claim/track/action-creators/index.js